import React,{ useEffect,useState,useContext } from 'react';
import { Link } from 'react-router-dom';
import { useEntityCrud } from '../../hooks/useEntityCrud';
import { Context } from '../../context/UserContext';
import Pagination from '../Common/Pagination';
import { toast } from 'react-toastify';
import DatePicker from '@hassanmojab/react-modern-calendar-datepicker';

const Index = () => {

    const context = useContext(Context);
    const {readData: readData} = useEntityCrud('Info/GetAllAnoncements');
    const [rows,setRows] = useState([]);

    const [title,setTitle] = useState('');
    const [fromDate,setFromDate] = useState('');
    const [toDate,setToDate] = useState('');

    const [lastPage,setLastPage] = useState(0);
    const [pages, setPages] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [count,setCount] = useState(0);

    const getData = () => {
        const postedData = {
            offset: 0,
            limit: 10
        };
        if(title)
            postedData.title = title;
        if(fromDate)
            postedData.fromDate = (fromDate.year.toString() + (fromDate.month > 9 ? fromDate.month : `0${fromDate.month}`).toString() + (fromDate.day > 9 ? fromDate.day : `0${fromDate.day}`).toString()).toString();
        if(toDate)
            postedData.toDate = (toDate.year.toString() + (toDate.month > 9 ? toDate.month : `0${toDate.month}`).toString() + (toDate.day > 9 ? toDate.day : `0${toDate.day}`).toString()).toString();
        readData(postedData).then(({data}) => {
            if(data.status){
                setRows(data.result);
                calcPages(data)
            }
        });
    }

    const resetFilters = () => {
        setTitle('');
        setFromDate('');
        setToDate('');
        readData({offset: 0,limit: 10}).then(res => {
            setRows(res.data.result)
            calcPages(res)
        });
    }

    useEffect(() => {
        getData();
    },[])

    const calcPages = res => {
        let calcPages = res.count / 10;
        setCount(res.count)

        calcPages = calcPages > 1 ? Math.ceil(calcPages) : 1
        let pagesArray = [];
        for (let i = 1; i <= calcPages; i++)
            pagesArray.push(i);
        setLastPage(pagesArray.length)
        setPages(pagesArray);
        setCurrentPage(1);
    }

    const changePage = (e, page) => {
        e.preventDefault();
        setCurrentPage(page);
        const postedData = {
            limit: 10,
            offset: page - 1
        };
        readData(postedData).then(res => {
            setRows(res.data.result);
        }).catch(err => err.data.errors.map(error => toast.error(error.message)));
    }

    const prevPage = e => {
        e.preventDefault();
        setCurrentPage(currentPage - 1);
        const postedData = {
            limit: 10,
            offset: currentPage - 2
        };
        readData(postedData).then(res => {
            setRows(res.data.result);
        }).catch(err => err.data.errors.map(error => toast.error(error.message)));
    }

    const nextPage = e => {
        e.preventDefault();
        setCurrentPage(currentPage + 1);
        const postedData = {
            limit: 10,
            offset: currentPage
        };
        readData(postedData).then(res => {
            setRows(res.data.result);
        }).catch(err => err.data.errors.map(error => toast.error(error.message)));
    }

    return (
        <div className="card">
            <div className="card-header">
                <div className="card-title">اطلاعیه ها</div>
            </div>
            <div className="card-body">
                {context.checkHasPermission('create') ? <Link className="btn btn-primary me-2" to="create">ایجاد اطلاعیه جدید</Link> : ''}
                <button className="btn btn-dark accordion-toggle collapsed" data-bs-toggle="collapse" href="#filter" aria-expanded="false">جستجو</button>
                <div id="filter" className="panel-collapse collapse position-relative mt-3" role="tabpanel" aria-expanded="false">
                    <div className="row">
                        <div className="col-md-3">
                            <div className="form-group">
                                <label> عنوان </label>
                                <input className="form-control" placeholder="عنوان" value={title} onChange={(e) => setTitle(e.target.value)} />
                            </div>
                        </div>
                        <div className="col-md-2">
                            <div className="form-group">
                                <label>از تاریخ</label>
                                {fromDate && <i class="fe fe-x clear-select-btn" onClick={() => setFromDate(null)} style={{left: 25}}></i>}
                                <DatePicker
                                    locale="fa"
                                    shouldHighlightWeekends
                                    value={fromDate}
                                    onChange={setFromDate}
                                    className="form-control my-1 pb-4"
                                />
                            </div>
                        </div>
                        <div className="col-md-2">
                            <div className="form-group">
                                <label>تا تاریخ</label>
                                {toDate && <i class="fe fe-x clear-select-btn" onClick={() => setToDate(null)} style={{left: 25}}></i>}
                                <DatePicker
                                    locale="fa"
                                    shouldHighlightWeekends
                                    value={toDate}
                                    onChange={setToDate}
                                    className="form-control my-1 pb-4"
                                />
                            </div>
                        </div>
                        <div className="col-md-4">
                            <button className="btn btn-primary me-2" onClick={getData} style={{marginTop: 30}}>جستجو</button>
                            {title || fromDate || toDate ? <button className="btn btn-danger" onClick={resetFilters} style={{marginTop: 30}}>بازنشانی</button> : ''}
                        </div>
                    </div>
                </div>
                {context.checkHasPermission('create') ? <hr /> : ''}
                {rows.length ? <div className="table-responsive"><table className="table table-bordered table-hover border text-nowrap text-md-nowrap">
                    <thead>
                        <tr>
                            <th>ردیف</th>
                            <th>عنوان</th>
                            <th>وضعیت</th>
                            <th>عملیات</th>
                        </tr>
                    </thead>
                    <tbody>
                        {rows.map((item,index) => (
                            <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{item.title}</td>
                                <td>{item.isActive ? 'فعال' : 'غیرفعال'}</td>
                                <td className="btn-list">
                                    {context.checkHasPermission('update') ? <Link to={'update/' + item.id} className="btn btn-icon mb-0 btn-primary" title="ویرایش"><i className="fe fe-edit-2"></i></Link> : ''}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                <p>تعداد کل ردیف ها : {rows.length}</p>
                <Pagination changePage={changePage} currentPage={currentPage} pages={pages} prevPageClick={prevPage} nextPageClick={nextPage} lastPage={lastPage} />
                </div> : <div className="alert alert-info"><p>اطلاعیه ای یافت نشد</p></div>}
            </div>
        </div>
    );
}

export default Index;